module.exports = __webpack_public_path__ + "static/media/solomon-islands.51b4e2a1.png";